import ReducerRegistry from '../base/redux/ReducerRegistry';
import { ADD_TMP_SESSION, AUTO_CALL, CHANGE_TOTAL_SIP_INSTANCE, CLEAR_DATA, CLEAR_ERROR_MSG_LOGIN, COUNT_CONFIG_SIP, DECREASE_TOTAL_SIP_INSTANCE, INCREASE_TOTAL_SIP_INSTANCE, SAVE_DATA, SAVE_OLD_NUMBER_CTH, SIP_GW_AVAILABILITY_CHANGED, TOTAL_IN } from './actionTypes';
ReducerRegistry.register('features/videosipgw', (state = {}, action) => {
    switch (action.type) {
        case SIP_GW_AVAILABILITY_CHANGED: {
            return {
                ...state,
                status: action.status
            };
        }
        case SAVE_DATA: {
            return {
                ...state,
                token: action.token,
                sipId: action.sipId,
                conference: action.conference,
                errorMessage: action.errorMessage,
                sessionsMap: new Map(),
                tmpSessions: new Map(),
                newToOld: new Map(),
                isInvited: false,
                totalIn: 0,
                successIn: 0,
                failedIn: 0,
                oldNumberCTH: 0,
                isActiveKick: 0,
                nameList: [],
                totalNumberIn: 0
            };
        }
        case CLEAR_DATA: {
            return {
                ...state,
                token: '',
                sipId: ''
            };
        }
        case CLEAR_ERROR_MSG_LOGIN: {
            return {
                ...state,
                errorMessage: ''
            };
        }
        case AUTO_CALL: {
            return {
                ...state,
                autoCall: true
            };
        }
        case TOTAL_IN: {
            return {
                ...state,
                totalIn: action.number
            };
        }
        case ADD_TMP_SESSION: {
            if (!state) {
                state = {};
            }
            var tmps = state.tmpSessions;
            if (!tmps) {
                tmps = new Map();
            }
            tmps.set(action.id, action.session);
            return {
                ...state,
                tmpSessions: tmps
            };
        }
        case SAVE_OLD_NUMBER_CTH: {
            return {
                ...state,
                oldNumberCTH: action.oldNumber
            };
        }
        case COUNT_CONFIG_SIP: {
            var tmpTotalNumberIn = state.totalNumberIn;
            tmpTotalNumberIn = tmpTotalNumberIn + action.numberIn;
            return {
                ...state,
                totalNumberIn: tmpTotalNumberIn
            };
        }
        case CHANGE_TOTAL_SIP_INSTANCE: {
            return {
                ...state,
                totalSipInstance: action.number
            };
        }
        case INCREASE_TOTAL_SIP_INSTANCE: {
            var totalSipInstance = state.totalSipInstance || 0;
            totalSipInstance = totalSipInstance + action.number;
            return {
                ...state,
                totalSipInstance: totalSipInstance
            };
        }
        case DECREASE_TOTAL_SIP_INSTANCE: {
            var totalSipInstance = state.totalSipInstance || 0;
            totalSipInstance = Math.max(0, (totalSipInstance || 0) - action.number);
            return {
                ...state,
                totalSipInstance: totalSipInstance
            };
        }
    }
    return state;
});
